import { BoxProps } from '@jfs/ui-new'

const columnWidthConstant = 170
const EmptyColumnConstant = 130

export const styles = {
  mainView: (isEmpty: boolean) =>
    ({
      flexDirection: 'row',
      borderWidth: isEmpty ? 0 : 1,
      pv: 8,
      width: EmptyColumnConstant,
      borderColor: 'LIGHTEST_GREY',
      ph: 12,
      bg: 'GRAY_HALF',
      alignSelf: 'flex-start',
    } as BoxProps),
  mainViewColumn: (isEmpty: boolean) =>
    ({
      flexDirection: 'column',
      borderWidth: isEmpty ? 0 : 1,
      justify: 'center',
      alignItems: 'center',
      pv: 4,
      width: columnWidthConstant,
      borderColor: 'LIGHTEST_GREY',
      ph: 12,
      bg: 'GRAY_HALF',
      alignSelf: 'flex-start',
    } as BoxProps),
  emptyColumn: {
    flexDirection: 'column',
    justify: 'center',
    alignItems: 'center',
    pv: 4,
    pl: 12,
    width: EmptyColumnConstant,
    borderColor: 'LIGHTEST_GREY',
    alignSelf: 'flex-start',
  } as BoxProps,
  header: {
    flexDirection: 'row',
  } as BoxProps,
  checkboxContainer: {
    pv: 10,
    width: columnWidthConstant,
    ph: 12,
    justify: 'center',
    borderWidth: 1,
    borderColor: 'LIGHTEST_GREY',
  } as BoxProps,
  individualCheckbox: {
    alignSelf: 'center',
  } as BoxProps,
  cardTypeBox: (numOfColumns: number) =>
    ({
      borderWidth: 1,

      pv: 10,
      width: (numOfColumns - 1) * columnWidthConstant,
      justify: 'center',
      alignItems: 'center',
      bg: 'GRAY_HALF',
      borderColor: 'LIGHTEST_GREY',
    } as BoxProps),
  cardTypeTextContainer: {
    w: EmptyColumnConstant,
    justify: 'center',
    alignContent: 'flex-end',
    pv: 4,
    pl: 12,
    alignItems: 'flex-end',
  } as BoxProps,
  cardSuperView: {
    flexDirection: 'row',
  } as BoxProps,
  checkboxContainerDropdown: {
    bg: 'WHITE',
    p: 7,
    borderWidth: 1,
    justify: 'center',
    borderColor: 'LIGHTEST_GREY',
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  } as BoxProps,
  dropdownContainer: {
    flexDirection: 'row',
  } as BoxProps,
  dropdownTextContainer: {
    paddingLeft: 10,
    justify: 'center',
    bg: 'WHITE',
  } as BoxProps,
  dropDownWithIcon: {
    borderColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    borderBottomRightRadius: 6,
    borderWidth: 1,
    borderTopRightRadius: 6,
    borderLeftWidth: 0,
    bg: 'WHITE',
  } as BoxProps,
  iconContainer: {
    p: 7,
    mr: 15,
    bg: 'TRANSPARENT',
  } as BoxProps,
}
